const LOGO = "/friib-logo.webp";

export default function Logo({ className = "h-8", onDark = false }) {
  if (onDark) {
    return (
      <span className={`inline-flex items-center bg-white rounded-xl px-2.5 py-1.5 ${className}`}>
        <img src={LOGO} alt="Friib" className="h-full w-auto" />
      </span>
    );
  }
  return <img src={LOGO} alt="Friib" className={`${className} w-auto`} />;
}
